var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-ag-grid',{attrs:{"title":"Users","columnDefs":_vm.columnDefs,"rowData":_vm.users,"loading":_vm.loading,"getRowStyle":_vm.getRowStyle,"mobileCard":_vm.mobileCard},on:{"refresh":_vm.fetchUsers,"add":_vm.onAdd,"row-dbl-click":(data) => _vm.$router.push({ path: `users/${data._id}/edit` })}})
}
var staticRenderFns = []

export { render, staticRenderFns }